
import qs from "qs";

const CryptoJS = require('crypto-js')

function encrypt(data) {
  var key = '79697368656e67746563686e6f6c6f6779636f6d70616e793230313930343131'
  key = CryptoJS.enc.Hex.parse(key)
  let iv = CryptoJS.enc.Hex.parse('79697368656e67746563684032303139')
  var enc = CryptoJS.AES.encrypt(data, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  })
  var enced = enc.ciphertext.toString()
  return enced
}

export default {
  data() {
    return {
      input: "",
      error: "",
    }
  },
  methods: {
    onSubmit() {
      this.error = ""
      var reg = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[~@#$%^&+=!()*]).*$/
      if (!reg.test(this.input)) {
        this.error = this.$t('append_field.please_enter_password')
        return
      }

      this.$ajax.post("/etv/updatePasswordToSafe.json", qs.stringify({
        password: encrypt(this.input)
      })).then(res => {
        if (res.data.code === 0) {
          this.$ajax.post('/etv/logout.json').then(() => {
            this.$router.push('/login')
            localStorage.clear()
          })
        }
      })
    },
    back() {
      this.$router.push('/login')
    }
  }
}
